import React from 'react';
import { Grid, Typography, styled, Chip, Box, CircularProgress, Backdrop } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';

const ScrollBox = styled(Box)(({ theme }) => ({
  backgroundColor: (theme.vars || theme).palette.background.paper,
  padding: theme.spacing(1),
  borderRadius: 8,
  maxHeight: 200,
  overflowY: 'auto',
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
  border: '1px solid #ddd'
}));
const ViewDetail = (props) => {
  const ViewData = props.ViewData;
  const stateIds = ViewData?.state_names || [];
  const districtIds = ViewData?.district_names || [];
  const ds_details = ViewData?.ds_details || [];
  const tm_details = ViewData?.tm_details || [];

  const DScolumns = [
    // { field: 'id', headerName: 'ID', width: 90 },
    {
      field: 'name',
      headerName: 'DS Name',
      width: 120
    },
    {
      field: 'code',
      headerName: 'DS Code',
      width: 100
    },
    {
      field: 'state',
      headerName: 'state',
      type: 'number',
      width: 100
    },
    {
      field: 'number',
      headerName: 'Mobile Number',
      type: 'number',
      width: 120
    }
  ];

  const TMcolumns = [
    // { field: 'id', headerName: 'ID', width: 90 },
    {
      field: 'name',
      headerName: 'TM Name',
      width: 120
    },
    {
      field: 'code',
      headerName: 'Employee ID',
      width: 100
    },
    {
      field: 'state',
      headerName: 'state',
      type: 'number',
      width: 100
    },
    {
      field: 'number',
      headerName: 'Mobile Number',
      type: 'number',
      width: 120
    }
  ];

  // const rows = [
  //   { id: 1, name: 'demo', number: '9987454514', code: 'demo', state: 'demo' },
  //   { id: 2, name: 'demo', number: '9987454531', code: 'demo', state: 'demo' }
  // ];

  const DSrows =
    ds_details && Array.isArray(ds_details)
      ? ds_details?.map((item, index) => ({
          id: index,
          name: item.ds_name ? item.ds_name : '-',
          code: item.ds_code ? item.ds_code : '-',
          number: item.ds_mobile ? item.ds_mobile : '-',
          state: item.ds_state ? item.ds_state : '-'
        }))
      : [];

  const TMrows =
    tm_details && Array.isArray(tm_details)
      ? tm_details?.map((item, index) => ({
          id: index,
          name: item.tm_name ? item.tm_name : '-',
          code: item.tm_code ? item.tm_code : '-',
          number: item.tm_mobile ? item.tm_mobile : '-',
          state: item.tm_state ? item.tm_state : '-'
        }))
      : [];
  return (
    <>
      <Backdrop open={props.Isloading} sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Grid container spacing={2} justifyContent="space-around" mb={2}>
        {/* Mapped States */}
        <Grid item xs={12} md={6}>
          <Typography sx={{ mt: 2, mb: 1 }} variant="h4">
            Mapped States
          </Typography>
          <ScrollBox>
            {stateIds.length > 0 ? (
              stateIds.map((stateId, idx) => (
                <Chip
                  label={stateId.state_name}
                  variant="outlined"
                  color="info"
                  sx={{
                    borderColor: '#688B2A',
                    color: '#688B2A'
                  }}
                  key={`state-${idx}`}
                  size="small"
                />
              ))
            ) : (
              <Typography variant="body2">No states mapped</Typography>
            )}
          </ScrollBox>
        </Grid>

        {/* Mapped Districts */}
        {props.FilterData.user_type !== 'sh' ? (
          <Grid item xs={12} md={6}>
            <Typography sx={{ mt: 2, mb: 1 }} variant="h4">
              Mapped Districts
            </Typography>
            <ScrollBox>
              {districtIds?.length > 0 ? (
                districtIds?.map((districtId, idx) => (
                  <Chip
                    label={districtId?.district_name}
                    variant="outlined"
                    color="secondary"
                    sx={{
                      borderColor: '#592375',
                      color: '#592375'
                    }}
                    key={`district-${idx}`}
                    size="small"
                  />
                ))
              ) : (
                <Typography variant="body2">No districts mapped</Typography>
              )}
            </ScrollBox>
          </Grid>
        ) : (
          ''
        )}
      </Grid>
      <Grid container spacing={1}>
        {props.FilterData.user_type === 'tm' || props.FilterData.user_type === 'sh' ? (
          <Grid item xl={6} lg={6} md={6} sm={12}>
            <Typography sx={{ mt: 4, mb: 2 }} variant="h4" component="div">
              Mapped DS List
            </Typography>
            <DataGrid
              rows={DSrows}
              columns={DScolumns}
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 5,
                    page: 0
                  }
                }
              }}
              disableRowSelectionOnClick
            />
          </Grid>
        ) : (
          ''
        )}
        {props.FilterData.user_type === 'sh' ? (
          <Grid item xl={6} lg={6} md={6} sm={12}>
            <Typography sx={{ mt: 4, mb: 2 }} variant="h4" component="div">
              Mapped TM List
            </Typography>
            <DataGrid
              rows={TMrows}
              columns={TMcolumns}
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 5,
                    page: 0
                  }
                }
              }}
              disableRowSelectionOnClick
            />
          </Grid>
        ) : (
          ''
        )}
      </Grid>
    </>
  );
};

export default ViewDetail;
